import { useMyStore } from "src/components/main/mainStore";
import WorkLogForm from "../workLogForm"
//---------------------------------------------------
export default function GoodCatchForm({
    ...rest
}){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Individual Reporting", type: "text", required: true, default: user.userName}, 
        {title: "Date", type: "date", required: true}, 
        {title: "Time", type: "time"}, 
        {title: "Location", type:"text", required: true}, 
        {title: "BTL Associated", type: "text", required: true}, 
        {title: "What happened? How did you react to help/assist? Who was involved? When did you notice? Where did the details of the event occur?", type: "textarea", required: true},
    ];
    const Pre = <div className = "my-2 text-secondary font-weight-bold font-italic">
        <p>
            A Good Catch is recognition of an event or circumstance that had the potential to cause property damage or injury/illness but did not occur thanks to a corrective action and/or timely intervention following the reporting.
        </p>
        <p>
            Una buena captura es el reconocimiento de un evento o circunstancia que tenía el potencial de causar daños a la propiedad o lesiones / enfermedades, pero no ocurrió gracias a una acción correctiva y / o intervención oportuna después del informe.
        </p>
    </div>;
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            sendEmail
            prefix = {Pre}
            correctiveActionNeed = {true}
            picsLimit = {0}
            items = {items}
            {...rest}
        />
    )    
}